"use client";

import { useMemo } from "react";
import { useChatBot } from "@/features/chat";
import { PROFILE_SHAPING_LABELS } from "@/features/profile-shaping/config/actions";
import { useAuth, useUserChoices } from "@/state/globalStore";
import { useActionMenuContribution } from "@/app/private-shell";

export default function StudioActionMenuContribution() {
  const owner = "studio-route";
  const { isUserAdmin } = useAuth();
  const { handleChatWithProfileClick, preparingChat } = useChatBot();
  const { setInterimState, activeStudioExportLock } = useUserChoices();

  const quickActions = useMemo(
    () =>
      isUserAdmin
        ? [
            {
              key: "chat_profile",
              label: "Chat",
              humanReadable: "Chat with your profile",
              icon: "chat" as const,
              closeOnSelect: true,
              onSelect: handleChatWithProfileClick,
              disabled: preparingChat,
            },
          ]
        : [],
    [handleChatWithProfileClick, isUserAdmin, preparingChat],
  );

  const utilityActions = useMemo(
    () => [
      {
        key: "open_rerank",
        label: PROFILE_SHAPING_LABELS.tailorToFocus,
        humanReadable: "Choose the focus lens used to order the profile export",
        icon: "profile_focus" as const,
        closeOnSelect: true,
        onSelect: () => {
          setInterimState("rerank_dialog", { isOpen: true });
        },
        hidden: !activeStudioExportLock,
      },
    ],
    [activeStudioExportLock, setInterimState],
  );

  useActionMenuContribution({
    owner,
    quickActions,
    utilityActions,
  });

  return null;
}
